import { changeselectedtype } from './ActionTypes';

const changeSelectedType = (selectedType) => {
    return (dispatch)=>{
        dispatch({type: changeselectedtype, selectedType:selectedType})
    }
}

export default changeSelectedType;